import FaceBookAuthButton from './FaceBookAuthButton';

export default FaceBookAuthButton;


// WEBPACK FOOTER //
// ./src/components/FaceBookAuthButton/index.js